
(function() {
  var result = { translations: { "fi": { "foundations-components": { "ActionsMenu": { "defaultAriaLabel": "Toimenpiteet" }, "tag": { "remove": "Poista tunniste" }, "Select": { "noResults": "Tuloksia ei l\xF6ytynyt", "searchPlaceholder": "Hae...", "clearSelections": "Tyhjenn\xE4 valinnat" }, "ErrorMessage": { "error": { "title": "Kaikkea ei ole menetetty." }, "notFound": { "title": "Kaikki, jotka vaeltavat, eiv\xE4t ole eksyksiss\xE4." }, "badRequest": { "title": "T\xE4m\xE4n sivun lataamisessa oli ongelma." }, "expired": { "title": "Pahoittelut." }, "sessionId": { "prefix": "Istunnon tunnus: " } }, "ProgressSteps": { "completedStep": "Suoritettu vaihe", "incompleteStep": "Keskener\xE4inen vaihe" }, "Paginator": { "label": "Sivunumerointi", "pageNumber": { "currentIndicator": "Olet t\xE4ll\xE4 hetkell\xE4", "description": "Sivu" }, "firstPage": { "label": "Ensimm\xE4inen", "description": "Ensimm\xE4inen sivu" }, "previousPage": { "label": "Edellinen", "description": "Edellinen sivu" }, "nextPage": { "label": "Seuraava", "description": "Seuraava sivu" }, "lastPage": { "label": "Viimeinen", "description": "Viimeinen sivu" } }, "Datagrid": { "noData": { "Title": "Tietoja ei ole saatavilla", "Description": "N\xE4ytett\xE4vi\xE4 tietoja ei ole." }, "noResults": { "Title": "Tuloksia ei l\xF6ytynyt", "Description": "Muokkaa hakua ja suodattimia l\xF6yt\xE4\xE4ksesi etsim\xE4si.", "ClearActionLabel": "Tyhjenn\xE4 haku ja suodattimet" }, "toolbar": { "selectedRows": { "one": "{{count}} rivi valittu", "other": "{{count}} rivi\xE4 valittu", "clearSelection": "Poista valinnat", "selectAll": "Valitse kaikki {{totalRows}} rivi\xE4" }, "search": { "placeholder": "Haku", "label": "Haku", "clearSearch": "Tyhjenn\xE4 haku" } }, "pagination": { "visibleRows": "{{visibleRows}}/{{totalRows}} tulosta", "itemsPerPage": "Nimikkeit\xE4 sivua kohden", "countPerPage": { "one": "{{count}} sivua kohden", "other": "{{count}} sivua kohden" } }, "SkeletonGrid": { "loading": "Ladataan" }, "DataGridColumnManagementPanel": { "description": "Valitse, mitk\xE4 ominaisuudet n\xE4ytet\xE4\xE4n sarakkeina. Siirr\xE4 sen j\xE4lkeen ominaisuuksia yl\xF6s tai alas tai ved\xE4 ja pudota, jos haluat muuttaa niiden n\xE4ytt\xF6j\xE4rjestyst\xE4.", "removeAllColumns": "Poista kaikki sarakkeet", "update": "P\xE4ivit\xE4", "cancel": "Peruuta", "edit": "Muokkaa sarakkeita" } } }, "ui": { "UIAbstractPageSection": { "page": "Sivuosio" }, "UICarousel": { "current": "N\xE4ytet\xE4\xE4n kohde {{currentStepDisplayNumber}}/{{totalSteps}}", "prev": "Edellinen", "next": "Seuraava", "tip": "Katso muita kohteita k\xE4ytt\xE4m\xE4ll\xE4 nuolipainikkeita" }, "UIColorSwatch": { "label": "V\xE4rivalitsin {{value}}", "noColorLabel": "V\xE4rin poimintaty\xF6kalu, v\xE4ri\xE4 ei ole valittu." }, "UIButtonCollapser": { "dropdownLabel": "Toimenpiteet" }, "UIErrorMessage": { "error": { "title": "Kaikkea ei ole menetetty." }, "notFound": { "title": "Kaikki, jotka vaeltavat, eiv\xE4t ole eksyksiss\xE4." }, "badRequest": { "title": "T\xE4m\xE4n sivun lataamisessa oli ongelma." }, "expired": { "title": "Pahoittelut." } }, "UIPanelNavigator": { "backButton": "Siirry edelliseen n\xE4kym\xE4\xE4n" }, "UILoadingSpinner": { "busyText": "Ladataan", "completedText": "Ladattu" }, "UISideNav": { "navigationLandmark": "Toissijainen" }, "UISortTH": { "ascendingSort": "Nouseva j\xE4rjestys. Laskeva j\xE4rjestys painamalla.", "descendingSort": "Laskeva j\xE4rjestys. Nouseva j\xE4rjestys painamalla.", "pressToSort": "J\xE4rjest\xE4 painamalla." }, "autosizedTextInput": { "charactersRemaining": "{{value}} merkki\xE4 j\xE4ljell\xE4" }, "time": { "today": "T\xE4n\xE4\xE4n klo {{time}}", "yesterday": "Eilen klo {{time}}", "datetime": "{{date}} {{time}}" }, "progress": { "percentComplete": "{{percent}} valmis" }, "datePicker": { "dateSelected": "{{date}} on valittu", "noDateSelected": "P\xE4iv\xE4\xE4 ei ole valittu.", "dateBelowMin": "Sinun on valittava l\xE4hemp\xE4n\xE4 oleva p\xE4iv\xE4m\xE4\xE4r\xE4", "dateAboveMax": "Sinun on valittava aikaisemmin oleva p\xE4iv\xE4m\xE4\xE4r\xE4", "invalidDate": "Virheellinen p\xE4iv\xE4m\xE4\xE4r\xE4", "today": "T\xE4n\xE4\xE4n", "clear": "Tyhjenn\xE4", "placeholder": { "month": "KK", "day": "PP", "year": "VVVV" }, "nextMonth": "Seuraava kuukausi", "prevMonth": "Edellinen kuukausi" }, "dateRange": { "startDate": "Aloitusp\xE4iv\xE4", "endDate": "P\xE4\xE4ttymisp\xE4iv\xE4", "endDateBeforeStartDate": "P\xE4\xE4ttymisp\xE4iv\xE4n pit\xE4\xE4 olla aloitusp\xE4iv\xE4n j\xE4lkeen.", "startDateAfterEndDate": "Aloitusp\xE4iv\xE4n on oltava ennen p\xE4\xE4ttymisp\xE4iv\xE4\xE4.", "to": "p\xE4\xE4ttyen" }, "timePicker": { "placeholder": { "hour": "HH", "minute": "KK" } }, "SelectResultList": { "andMore": "... ja {{count}} lis\xE4\xE4.", "loadMore": "Lataa lis\xE4\xE4" } }, "salesUI": { "UIAvatarAdd": { "ariaLabel": "Lis\xE4\xE4" }, "UIAvatarHoverlay": { "text": "Vaihda kuva" }, "UIChangeArrow": { "decrease": "V\xE4hennys:", "increase": "Lis\xE4ys:" }, "UICopyInput": { "label": "Kopioi", "title": "Kopioi leikep\xF6yd\xE4lle", "tooltipCopied": "Kopioitu" }, "UIConfirm": { "defaultConfirm": "Kyll\xE4", "defaultReject": "Ei" }, "UICloseButton": { "label": "Sulje" }, "UIDateRangePicker": { "rangeType": { "ALL": "Koko aikana", "THIS_DAY": "T\xE4n\xE4\xE4n", "LAST_DAY": "Eilen", "THIS_WEEK": "T\xE4ll\xE4 viikolla", "LAST_WEEK": "Viime viikolla", "THIS_MONTH": "T\xE4ss\xE4 kuussa", "LAST_MONTH": "Viime kuukausi", "LAST_THIRTY_DAYS": "Viimeiset 30 p\xE4iv\xE4\xE4", "LAST_THREE_MONTHS": "Viimeiset 3 kuukautta", "THIS_QUARTER": "T\xE4m\xE4 vuosinelj\xE4nnes", "LAST_QUARTER": "Viimeinen vuosinelj\xE4nnes", "THIS_YEAR": "T\xE4m\xE4 vuosi", "LAST_YEAR": "Viime vuosi", "CUSTOM": "Mukautettu ajanjakso" } }, "UIDropdownSelect": { "placeholder": "Mit\xE4\xE4n arvoa ei ole valittu" }, "UIEditableControls": { "cancel": "Peruuta", "save": "Tallenna" }, "UIExpandableText": { "collapseButtonText": "N\xE4yt\xE4 v\xE4hemm\xE4n", "expandButtonText": "N\xE4yt\xE4 enemm\xE4n" }, "UIFileInput": { "defaultChangeLabel": "Vaihda tiedosto", "defaultSelectLabel": "Valitse tiedosto" }, "UIIconRating": { "ariaValueText": "{{value}}/{{maxValue}}" }, "UILink": { "externalTitle": "Linkki avautuu uuteen ikkunaan" }, "UILoading": { "title": "Ladataan\u2026" }, "UILockBadge": { "title": "T\xE4m\xE4 toiminto on lukittu" }, "UIPaginator": { "label": "Sivunumerointi", "pageNumber": { "currentIndicator": "Olet t\xE4ll\xE4 hetkell\xE4", "description": "Sivu" }, "firstPage": { "label": "Ensimm\xE4inen", "description": "Ensimm\xE4inen sivu" }, "previousPage": { "label": "Edellinen", "description": "Edellinen sivu" }, "nextPage": { "label": "Seuraava", "description": "Seuraava sivu" }, "lastPage": { "label": "Viimeinen", "description": "Viimeinen sivu" } }, "UIPreviousButton": { "label": "Edellinen" }, "UINextButton": { "label": "Seuraava" }, "UINumberRating": { "lowRangeLabel": "Olen t\xE4ysin eri mielt\xE4", "highRangeLabel": "Olen eritt\xE4in samaa mielt\xE4" }, "UISearchableSelectInput": { "placeholder": "Haku" }, "UISearchInput": { "placeholder": "Haku", "minimumSearchMessage": { "one": "Kirjoita 1 merkki lis\xE4\xE4", "other": "Kirjoita {{count}} merkki\xE4 lis\xE4\xE4" }, "clearButton": "Tyhjenn\xE4 sy\xF6tt\xF6kentt\xE4" }, "UISelect": { "allOptionsSelected": "Kaikki vaihtoehdot on valittu", "createOption": "Luo vaihtoehto \"{{label}}\"", "plusMore": "+ {{count}} lis\xE4\xE4", "andMore": "... ja {{count}} lis\xE4\xE4.", "loadMore": "Lataa lis\xE4\xE4", "noResults": "Tuloksia ei l\xF6ytynyt", "placeholder": "Haku", "typeToSearch": "Hae kirjoittamalla" }, "UITable": { "selectableTableRow": { "toggleSelection": "Vaihtele rivin valintaa" } }, "UITabs": { "moreDropdownLabel": "Lis\xE4\xE4" }, "UITeaseNotification": { "optionsButtonTooltipText": "N\xE4yt\xE4 vaihtoehdot" }, "UITimePicker": { "placeholder": "Valitse aika" }, "UIToggle": { "checkedLabel": "K\xC4YT\xD6SS\xC4", "uncheckedLabel": "POIS" }, "UITypeahead": { "noMatchesFound": "T\xE4sm\xE4\xE4vi\xE4 tuloksia ei l\xF6ytynyt", "noOptions": "Ei mit\xE4\xE4n" }, "UIWizard": { "back": "Takaisin", "cancel": "Peruuta", "done": "Valmis", "next": "Seuraava", "stepCount": "Vaihe {{stepNumber}}/{{stepCount}}" }, "XSSTooltip": { "explanation": "T\xE4m\xE4 linkki on poistettu k\xE4yt\xF6st\xE4 turvallisuutesi vuoksi." } } } } };
  result.translationsLoaded = {
  "foundations-components": {
    "fi": "static-1.5429"
  }
};
  result.translationsAvailable = {
  "foundations-components": {
    "af": "static-1.5429",
    "ar-eg": "static-1.5429",
    "bg": "static-1.5429",
    "bn": "static-1.5429",
    "ca-es": "static-1.5429",
    "cs": "static-1.5429",
    "da": "static-1.5429",
    "de": "static-1.5429",
    "el": "static-1.5429",
    "en-gb": "static-1.5429",
    "en": "static-1.5429",
    "es-mx": "static-1.5429",
    "es": "static-1.5429",
    "et": "static-1.5429",
    "fi": "static-1.5429",
    "fr-ca": "static-1.5429",
    "fr": "static-1.5429",
    "he-il": "static-1.5429",
    "hi": "static-1.5429",
    "hr": "static-1.5429",
    "hu": "static-1.5429",
    "id": "static-1.5429",
    "it": "static-1.5429",
    "ja": "static-1.5429",
    "ko": "static-1.5429",
    "lt": "static-1.5429",
    "ms": "static-1.5429",
    "nl": "static-1.5429",
    "no": "static-1.5429",
    "pl": "static-1.5429",
    "pt-br": "static-1.5429",
    "pt-pt": "static-1.5429",
    "ro": "static-1.5429",
    "ru": "static-1.5429",
    "sk": "static-1.5429",
    "sl": "static-1.5429",
    "sv": "static-1.5429",
    "th": "static-1.5429",
    "tl": "static-1.5429",
    "tr": "static-1.5429",
    "uk": "static-1.5429",
    "vi": "static-1.5429",
    "zh-cn": "static-1.5429",
    "zh-hk": "static-1.5429",
    "zh-tw": "static-1.5429"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:foundations-components:fi', {version: 'static-1.5429'}); }
})();



(function() {
  var result = { translations: { "fi": { "placeholder": "paikkamerkki" } } };
  result.translationsLoaded = {
  "UIComponents": {
    "fi": "static-3.6772"
  }
};
  result.translationsAvailable = {
  "UIComponents": {
    "af": "static-3.6772",
    "ar-eg": "static-3.6772",
    "bg": "static-3.6772",
    "bn": "static-3.6772",
    "ca-es": "static-3.6772",
    "cs": "static-3.6772",
    "da": "static-3.6772",
    "de": "static-3.6772",
    "el": "static-3.6772",
    "en-gb": "static-3.6772",
    "en": "static-3.6772",
    "es-mx": "static-3.6772",
    "es": "static-3.6772",
    "et": "static-3.6772",
    "fi": "static-3.6772",
    "fr-ca": "static-3.6772",
    "fr": "static-3.6772",
    "he-il": "static-3.6772",
    "hi": "static-3.6772",
    "hr": "static-3.6772",
    "hu": "static-3.6772",
    "id": "static-3.6772",
    "it": "static-3.6772",
    "ja": "static-3.6772",
    "ko": "static-3.6772",
    "lt": "static-3.6772",
    "ms": "static-3.6772",
    "nl": "static-3.6772",
    "no": "static-3.6772",
    "pl": "static-3.6772",
    "pt-br": "static-3.6772",
    "pt-pt": "static-3.6772",
    "ro": "static-3.6772",
    "ru": "static-3.6772",
    "sk": "static-3.6772",
    "sl": "static-3.6772",
    "sv": "static-3.6772",
    "th": "static-3.6772",
    "tl": "static-3.6772",
    "tr": "static-3.6772",
    "uk": "static-3.6772",
    "vi": "static-3.6772",
    "zh-cn": "static-3.6772",
    "zh-hk": "static-3.6772",
    "zh-tw": "static-3.6772"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:UIComponents:fi', {version: 'static-3.6772'}); }
})();



(function() {
  var result = { translations: { "fi": { "app": { "htmlTitle": "Viraalien linkkien k\xE4ytt\xF6liittym\xE4", "welcomeHome": "Tervetuloa aloitussivulle, {{ firstName }}", "yourAppIsReady": "Sovelluksesi on valmis", "aSecondPage": "Toinen sivu lis\xE4sis\xE4ll\xF6lle", "fillPage_jsx": function (createElement, options, props) { return createElement( options, "wrapper", null, "T\xE4yt\xE4 t\xE4m\xE4 tyhj\xE4 sivu ", createElement( options, "Link", props.linkProps, "komponenteilla" ), " l\xE4hteest\xE4 ", createElement( options, "code", null, props.filename ), "." ); }, "viralLinks": { "forms": { "linkCta": "<strong>Luo omat ilmaiset lomakkeesi</strong> luodaksesi viittauksia verkkosivustostasi." }, "liveChat": { "linkCta": "<strong>Lis\xE4\xE4 live-chat.</strong> Ole yhteydess\xE4 k\xE4vij\xF6ihin. Ilmaiseksi.", "ariaLabel": "Lis\xE4\xE4 live-chat. Ole yhteydess\xE4 k\xE4vij\xF6ihin. Ilmaiseksi." }, "liveChatIntermediate": { "linkCta": "<strong>[Int] Lis\xE4\xE4 live-chat.</strong> Ole yhteydess\xE4 k\xE4vij\xF6ihin. Ilmaiseksi.", "ariaLabel": "[Int] Lis\xE4\xE4 live-chat. Ole yhteydess\xE4 k\xE4vij\xF6ihin. Ilmaiseksi." }, "meetings": { "linkCta": "<strong>Luo ilmainen kokousvaraussivusi</strong>, jotta voit aikatauluttaa kokouksia nopeammin." } } } } } };
  result.translationsLoaded = {
  "embedded-viral-link-ui": {
    "fi": "static-1.4487"
  }
};
  result.translationsAvailable = {
  "embedded-viral-link-ui": {
    "af": "static-1.4487",
    "ar-eg": "static-1.4487",
    "bg": "static-1.4487",
    "bn": "static-1.4487",
    "ca-es": "static-1.4487",
    "cs": "static-1.4487",
    "da": "static-1.4487",
    "de": "static-1.4487",
    "el": "static-1.4487",
    "en-gb": "static-1.4487",
    "en": "static-1.4487",
    "es-mx": "static-1.4487",
    "es": "static-1.4487",
    "et": "static-1.4487",
    "fi": "static-1.4487",
    "fr-ca": "static-1.4487",
    "fr": "static-1.4487",
    "he-il": "static-1.4487",
    "hi": "static-1.4487",
    "hr": "static-1.4487",
    "hu": "static-1.4487",
    "id": "static-1.4487",
    "it": "static-1.4487",
    "ja": "static-1.4487",
    "ko": "static-1.4487",
    "lt": "static-1.4487",
    "ms": "static-1.4487",
    "nl": "static-1.4487",
    "no": "static-1.4487",
    "pl": "static-1.4487",
    "pt-br": "static-1.4487",
    "pt-pt": "static-1.4487",
    "ro": "static-1.4487",
    "ru": "static-1.4487",
    "sk": "static-1.4487",
    "sl": "static-1.4487",
    "sv": "static-1.4487",
    "th": "static-1.4487",
    "tl": "static-1.4487",
    "tr": "static-1.4487",
    "uk": "static-1.4487",
    "vi": "static-1.4487",
    "zh-cn": "static-1.4487",
    "zh-hk": "static-1.4487",
    "zh-tw": "static-1.4487"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:embedded-viral-link-ui:fi', {version: 'static-1.4487'}); }
})();


